import type { ColumnLinks, PromoCard } from '../types';

export const title = '';
export const subtitle = 'Tools, calculators, FAQs, market insights & more';

export const learnLinks: ColumnLinks = {
  title: 'Learn',
  links: [
    { text: 'Insights & Guidance', href: 'https://www.thrivent.com/insights' },
    {
      text: 'Financial Education Events',
      href: 'https://www.thrivent.com/financial-education-events',
    },
    {
      text: 'Market & Economic Update',
      href: 'https://www.thrivent.com/market-economic-update',
    },
    {
      text: 'Tools & Calculators',
      href: 'https://www.thrivent.com/tools-and-calculators',
    },
  ],
};

export const getHelpLinks: ColumnLinks = {
  title: 'Get help',
  links: [
    {
      text: 'Client Resources',
      href: 'https://www.thrivent.com/client-resources',
    },
    { text: 'Contact Us', href: 'https://www.thrivent.com/about-us/support' },
    { text: 'FAQs', href: 'https://www.thrivent.com/about-us/faq' },
  ],
};

export const promoCard: PromoCard = {
  title: 'Looking for a specific form?',
  description:
    'Get quick access and download important forms or access online applications below.',
  callToActionText: 'Search forms',
  callToActionHref: 'https://www.thrivent.com/forms',
};
